module.exports = __webpack_public_path__ + "img/step-3.b2aaed93.png";